var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { withPathPrefix } from "../../common/helpers";
import axios from "axios";
function appendFormData(formData, payload) {
    formData.append("LeadOfferForm[user_change]", payload.user_change);
    if (payload.user_param_change) {
        formData.append("LeadOfferForm[user_param_change]", payload.user_param_change);
    }
    formData.append("LeadOfferForm[version]", payload.version);
    formData.append("LeadOfferForm[version_codes]", payload.version_codes);
    formData.append("LeadOfferForm[code]", payload.code);
    formData.append("LeadOfferForm[color]", payload.color);
    formData.append("LeadOfferForm[lead_brand]", payload.lead_brand);
    formData.append("LeadOfferForm[vin]", payload.vin);
    formData.append("LeadOfferForm[experiment]", "");
    formData.append("LeadOfferForm[context]", "");
    formData.append("LeadOfferForm[cta_placement]", "");
    if (payload.finance_type) {
        formData.append("LeadOfferForm[finance_type]", payload.finance_type);
    }
    if (payload.offer_type) {
        formData.append("LeadOfferForm[offer_type]", payload.offer_type);
    }
    if (payload.contract_period !== undefined && payload.contract_period !== "") {
        formData.append("LeadOfferForm[contract_period]", String(payload.contract_period));
    }
    if (payload.contribution !== undefined && payload.contribution !== "") {
        formData.append("LeadOfferForm[contribution]", String(payload.contribution));
    }
    if (payload.repurchase !== undefined && payload.repurchase !== "") {
        formData.append("LeadOfferForm[repurchase]", String(payload.repurchase));
    }
    if (payload.mileage !== undefined && payload.mileage !== "") {
        formData.append("LeadOfferForm[mileage]", String(payload.mileage));
    }
    if (payload.packages) {
        Object.entries(payload.packages).forEach(([id, val]) => {
            formData.append(`LeadOfferForm[packages][${id}]`, val);
        });
    }
}
export function fetchPrice(payload, signal) {
    return __awaiter(this, void 0, void 0, function* () {
        const formData = new FormData();
        appendFormData(formData, payload);
        const response = yield axios.post(withPathPrefix("/model/price"), formData, {
            signal,
            headers: {
                "X-Requested-With": "XMLHttpRequest",
            },
        });
        return response.data;
    });
}
export function getConfigValue(config, name) {
    return config.find((c) => c.name === name);
}
export function buildPayloadFromState(bootstrap, state) {
    return {
        user_change: state.user_change,
        user_param_change: state.user_param_change,
        code: state.code,
        version: bootstrap.version,
        version_codes: bootstrap.versionCodes,
        color: bootstrap.color,
        lead_brand: bootstrap.leadBrand,
        vin: bootstrap.vin,
        finance_type: state.finance_type,
        offer_type: state.offer_type,
        contract_period: state.contract_period,
        contribution: state.contribution,
        repurchase: state.repurchase,
        mileage: state.mileage,
        packages: state.packages,
    };
}
